import React, {Fragment} from 'react';
import {Input} from 'sulu-admin-bundle/components';
import {SingleSelect, ColorPicker} from 'sulu-admin-bundle/containers/Form';
// import {Select, Option} from 'sulu-admin-bundle/containers/Form';

export default ({name, label, custom, onChange, dataPath, style, disable}) => {

	const clrInputsCSS = { 
		display : 'flex',
		flexDirection: 'row',
    	gap: '20px'
	}


	const schemaOptions = {
		default_values: {
            name: 'default_values',
            value: [{name: 'blue'}]
        },
        values: {
            name: 'values',
            value: [
                {
                    name: 'blue',
                    title: 'Blue',
                },
                {
                    name: 'green',
                    title: 'Green',
                },
                {
                    name: 'yellow',
                    title: 'Yellow',
                },
                {
                    name: 'red',
                    title: 'Red',
                },
            ],
        },
    };

	const fieldTypeDefaultProps = {
	    data: {}, //all the context
	    dataPath: dataPath, 
	    defaultType: undefined,
	    disabled: undefined,
	    error: undefined,
	    fieldTypeOptions: {},
	    label: 'none',
	    maxOccurs: undefined,
	    minOccurs: undefined,
	    // $FlowFixMe
	    onChange: ()=>{alert('some')},
	    // $FlowFixMe
	    onFinish: ()=>{},
	    onSuccess: undefined,
	    router: undefined,
	    schemaOptions: {},
	    schemaPath: '/',
	    showAllErrors: false,
	    types: undefined,
	    value: custom,
	};


	return (
			<div className="color-top" style={style}>
				<label style={{color: '#595959', fontSize: '14px'}}>{label}</label>
				{disable && <label style={{color: '#595959', fontSize: '14px', fontWeight: '700'}}>: {custom}</label>}
				{!disable && 
					<div className="color-inputs" style={ clrInputsCSS }>
					
						<ColorPicker
							onBlur={()=>console.log('ads')}
							onChange={(val)=>{
		                    		return onChange({'name':name, type:'custom', value: val})
		                    	}
		                    }
		                    value={custom}
						/>

					</div>
				}
				
			</div>
		);
}